import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import english from "./en.json"
import spanish from "./es.json"
const resources = {
  en: {
    translation: english,
  },
  es: {
    translation: spanish,
  },
};

i18n.use(initReactI18next).use(LanguageDetector).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
